export class CommonErrorCodes {
  static NOT_FOUND = "NOT_FOUND";
  static INCORRECT_STATE: "INCORRECT_STATE";
  static API_ERROR: "API_ERROR";
  static AUTH_ERROR: "AUTH_ERROR";
  static COGNITO_AUTH_ERROR: "COGNITO_AUTH_ERROR";
}
